module.exports = __webpack_public_path__ + "img/glogo10.0cf51f5f.png";